import { useState, useEffect, useCallback } from 'react';
import { loginAdmin, logoutAdmin, getAdminSession } from '../utils/api';

/**
 * Custom hook for admin authentication state and actions
 */
export function useAuth() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminEmail, setAdminEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Check existing session on mount
  useEffect(() => {
    let mounted = true;
    async function verify() {
      try {
        const session = await getAdminSession();
        if (mounted && session && session.email) {
          setIsAdmin(true);
          setAdminEmail(session.email);
        }
      } catch (e) {
        // Not authenticated
      } finally {
        if (mounted) setIsLoading(false);
      }
    }
    verify();
    return () => { mounted = false; };
  }, []);

  const login = useCallback(async (email) => {
    setError(null);
    setIsLoading(true);
    try {
      const res = await loginAdmin(email);
      if (res && (res.token || res.success)) {
        setIsAdmin(true);
        setAdminEmail(res.admin?.email || 'ducnhan762013@gmail.com');
        return { success: true };
      }
      throw new Error('Authentication failed');
    } catch (err) {
      const msg = err.message || 'Access denied';
      setError(msg);
      return { success: false, error: msg };
    } finally {
      setIsLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    setIsLoading(true);
    try {
      await logoutAdmin();
      setIsAdmin(false);
      setAdminEmail(null);
      setError(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isAdmin,
    adminEmail,
    isLoading,
    error,
    login,
    logout,
    clearError: () => setError(null)
  };
}
